import { useState } from 'react';

export default function Home() {
  const [purchaseUrl] = useState('https://docs.google.com/forms/d/e/1FAIpQLSdM7tQ90Wu_Q24n_aW7SLCQFRS6BZ7DCIhVfG3hRnEMwomToQ/viewform?usp=publish-editor');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* ヘッダー */}
      <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <a href="/" className="flex items-center gap-3 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/9a1512bab4190ab0a228d64d8d4a8f0a/2594d362aebf6344cbc924cc76664b34.jpeg" 
                alt="Somachi ロゴ"
                className="h-12 w-auto object-contain"
              />
              <span className="text-xl font-bold text-gray-900 whitespace-nowrap" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>Somachi</span>
            </a>
            
            {/* デスクトップナビゲーション */}
            <nav className="hidden md:flex space-x-8">
              <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-sky-600 transition-colors whitespace-nowrap cursor-pointer">
                ソマチッドとは
              </button>
              <button onClick={() => scrollToSection('features')} className="text-gray-700 hover:text-sky-600 transition-colors whitespace-nowrap cursor-pointer">
                特徴
              </button>
              <button onClick={() => scrollToSection('usage')} className="text-gray-700 hover:text-sky-600 transition-colors whitespace-nowrap cursor-pointer">
                使い方
              </button>
              <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-sky-600 transition-colors whitespace-nowrap cursor-pointer">
                FAQ
              </button>
            </nav>

            {/* モバイルメニューボタン */}
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
            </button>
          </div>

          {/* モバイルメニュー */}
          {isMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-100">
              <button onClick={() => scrollToSection('about')} className="block w-full text-left py-2 text-gray-700 hover:text-sky-600 transition-colors cursor-pointer">
                ソマチッドとは
              </button>
              <button onClick={() => scrollToSection('features')} className="block w-full text-left py-2 text-gray-700 hover:text-sky-600 transition-colors cursor-pointer">
                特徴
              </button>
              <button onClick={() => scrollToSection('usage')} className="block w-full text-left py-2 text-gray-700 hover:text-sky-600 transition-colors cursor-pointer">
                使い方
              </button>
              <button onClick={() => scrollToSection('faq')} className="block w-full text-left py-2 text-gray-700 hover:text-sky-600 transition-colors cursor-pointer">
                FAQ
              </button>
            </div>
          )}
        </div>
      </header>

      {/* ファーストビュー */}
      <section className="relative pt-24 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-white via-sky-50/30 to-blue-50/40">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            知る人ぞ知る"古代ソマチッド"を、<br className="hidden sm:block" />あなたの毎日に。
          </h1>
          <p className="text-lg sm:text-xl text-gray-600 mb-10 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            Somachiは、何千万年もの地層から採れる鉱石に含まれる"古代ソマチッド"に着目したセルフケアアイテムブランドです。
          </p>
          
          {/* 商品画像追加 */}
          <div className="flex justify-center gap-6 mb-10">
            <div className="w-64 h-64 rounded-2xl overflow-hidden shadow-lg bg-white p-4">
              <img 
                src="https://static.readdy.ai/image/9a1512bab4190ab0a228d64d8d4a8f0a/61d0f362ed98bb82b297d08f9bf68d0b.png" 
                alt="Somachi 商品画像"
                className="w-full h-full object-contain"
              />
            </div>
          </div>

          <a 
            href={purchaseUrl || '#'} 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-sky-600 hover:bg-sky-700 text-white text-lg font-semibold px-12 py-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Somachiを購入する
          </a>
        </div>
      </section>

      {/* ソマチッドとは */}
      <section id="about" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center text-gray-900 mb-12" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            ソマチッドとは？
          </h2>
          
          <div className="bg-gradient-to-br from-sky-50/50 to-blue-50/30 rounded-3xl p-8 sm:p-12">
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-sky-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-microscope-line text-4xl text-sky-600"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                  超微小な粒子
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  ソマチッドは生命体に存在すると言われる超微小な粒子で、研究者によって数十年前から注目されています。
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-sky-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-earth-line text-4xl text-sky-600"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                  古代の地層から
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  古代の地層から採れる鉱石に含まれる"古代ソマチッド"は活動が活発であると考えられています。
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-sky-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-heart-pulse-line text-4xl text-sky-600"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                  健康意識の高い人に
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  健康意識の高い人々から注目されている、自然由来のセルフケアアプローチです。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Somachiの特徴 */}
      <section id="features" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-gray-50/50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center text-gray-900 mb-4" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            Somachiの特徴
          </h2>
          <p className="text-center text-gray-600 mb-12 text-lg">
            毎日の生活に自然に取り入れられる3つのポイント
          </p>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-shadow duration-300">
              <div className="w-full h-48 mb-6 rounded-xl overflow-hidden bg-[#F5F3EF] flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/9a1512bab4190ab0a228d64d8d4a8f0a/61d0f362ed98bb82b297d08f9bf68d0b.png" 
                  alt="古代ソマチッドを含む鉱石"
                  className="w-full h-full object-contain p-4"
                />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                古代ソマチッドを含む鉱石を採用
              </h3>
              <p className="text-gray-600 leading-relaxed">
                何千万年もの時を経た地層から採れる鉱石に含まれる古代ソマチッドに着目。自然の力をそのまま活かしています。
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-shadow duration-300">
              <div className="w-full h-48 mb-6 rounded-xl overflow-hidden">
                <img 
                  src="https://public.readdy.ai/ai/img_res/9ef4765012e5f01d75cf1647fe63134e.jpg" 
                  alt="日常で使えるSomachi"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                "置くだけ・入れるだけ"で日常で使える
              </h3>
              <p className="text-gray-600 leading-relaxed">
                複雑な手順は不要。水に入れたり、空間に置いたりするだけで、毎日の生活に自然に取り入れられます。
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-shadow duration-300">
              <div className="w-full h-48 mb-6 rounded-xl overflow-hidden bg-[#F5F3EF] flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/9a1512bab4190ab0a228d64d8d4a8f0a/b2670830f81d2be65f77cddeef57e041.png" 
                  alt="Somachiラインナップ - 石タイプと粉タイプ"
                  className="w-full h-full object-contain p-4"
                />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                続けやすい価格・ラインナップ
              </h3>
              <p className="text-gray-600 leading-relaxed mb-3">
                石タイプと粉タイプの2種類をご用意。石タイプは水に入れて繰り返し使える経済的なタイプ、粉タイプは水に溶けやすく扱いやすい微粒子タイプです。
              </p>
              <p className="text-gray-600 leading-relaxed text-sm">
                ライフスタイルや用途に合わせてお選びいただけます。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 使い方イメージ */}
      <section id="usage" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center text-gray-900 mb-12" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            使い方イメージ
          </h2>

          <div className="space-y-8">
            <div className="bg-gradient-to-r from-sky-50/50 to-blue-50/30 rounded-2xl p-8 sm:p-10">
              <div className="flex flex-col md:flex-row items-center gap-6">
                <div className="w-full md:w-1/3">
                  <div className="w-full h-64 rounded-xl overflow-hidden shadow-md bg-white flex items-center justify-center p-6">
                    <img 
                      src="https://static.readdy.ai/image/9a1512bab4190ab0a228d64d8d4a8f0a/61d0f362ed98bb82b297d08f9bf68d0b.png" 
                      alt="Somachi 使用イメージ"
                      className="w-full h-full object-contain"
                    />
                  </div>
                </div>
                <div className="w-full md:w-2/3">
                  <div className="flex items-start gap-6">
                    <div className="w-12 h-12 bg-sky-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-cup-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                        Somachi をコップの水に沈めるだけ
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        毎日飲む水に入れるだけのシンプルな使い方。朝起きたとき、仕事中、リラックスタイムなど、いつでもお使いいただけます。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-blue-50/30 to-sky-50/50 rounded-2xl p-8 sm:p-10">
              <div className="flex flex-col md:flex-row-reverse items-center gap-6">
                <div className="w-full md:w-1/3">
                  <div className="w-full h-64 rounded-xl overflow-hidden shadow-md bg-white flex items-center justify-center p-6">
                    <img 
                      src="https://static.readdy.ai/image/9a1512bab4190ab0a228d64d8d4a8f0a/69a4bf79c124cede77ca927b1052a1f2.png" 
                      alt="Somachi 使用イメージ"
                      className="w-full h-full object-contain"
                    />
                  </div>
                </div>
                <div className="w-full md:w-2/3">
                  <div className="flex items-start gap-6">
                    <div className="w-12 h-12 bg-sky-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-home-heart-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                        空間に置くだけで Somachi が生活環境をサポート
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        リビング、寝室、オフィスなど、過ごす空間に置いておくだけ。持ち運びも簡単で、出張先や旅行先でもご使用いただけます。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 p-6 bg-gray-50 rounded-xl border border-gray-200">
            <p className="text-sm text-gray-600 text-center">
              <i className="ri-information-line text-sky-600 mr-2"></i>
              使い方の詳細は公式サイトをご確認ください
            </p>
          </div>
        </div>
      </section>

      {/* こんな方に選ばれています */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-sky-50/20">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center text-gray-900 mb-12" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            こんな方に選ばれています
          </h2>

          <div className="grid sm:grid-cols-2 gap-6">
            <div className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm">
              <div className="w-10 h-10 bg-sky-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-leaf-line text-xl text-sky-600"></i>
              </div>
              <p className="text-gray-700 leading-relaxed">
                自然由来のケアを取り入れたい
              </p>
            </div>

            <div className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm">
              <div className="w-10 h-10 bg-sky-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-calendar-check-line text-xl text-sky-600"></i>
              </div>
              <p className="text-gray-700 leading-relaxed">
                毎日無理なく続けられるものが良い
              </p>
            </div>

            <div className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm">
              <div className="w-10 h-10 bg-sky-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-heart-3-line text-xl text-sky-600"></i>
              </div>
              <p className="text-gray-700 leading-relaxed">
                サプリよりも"モノ"で体を整えるのが好き
              </p>
            </div>

            <div className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm">
              <div className="w-10 h-10 bg-sky-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-user-star-line text-xl text-sky-600"></i>
              </div>
              <p className="text-gray-700 leading-relaxed">
                情報に流されず、自分で選びたい
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* お客様の声 */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-14">
            <p className="text-sky-600 font-medium text-sm tracking-widest mb-3">VOICE</p>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
              お客様の声
            </h2>
            <p className="text-gray-500 max-w-xl mx-auto">
              Somachiをご愛用いただいているお客様から寄せられた感想をご紹介します。
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {/* レビュー1 */}
            <div className="bg-gradient-to-br from-sky-50/60 to-white rounded-2xl p-7 shadow-sm border border-sky-100/80 hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-yellow-400 text-base"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed mb-5 text-sm">
                毎日コップに入れるだけなのでとにかくラクです。サプリのように飲み忘れることもなく、自然と習慣になりました。<strong>続けやすさが一番のポイント</strong>だと思います。
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-10 h-10 rounded-full bg-sky-100 flex items-center justify-center">
                  <i className="ri-user-3-line text-sky-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-800">M.T さん</p>
                  <p className="text-xs text-gray-400">50代・女性｜石タイプ愛用</p>
                </div>
              </div>
            </div>

            {/* レビュー2 */}
            <div className="bg-gradient-to-br from-blue-50/40 to-white rounded-2xl p-7 shadow-sm border border-blue-100/80 hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-yellow-400 text-base"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed mb-5 text-sm">
                出張先にも持っていけるサイズ感がいいですね。コンパクトで邪魔にならないし、<strong>ホテルの部屋にも置いておける</strong>のが気に入っています。
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                  <i className="ri-user-3-line text-blue-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-800">K.S さん</p>
                  <p className="text-xs text-gray-400">40代・男性｜石タイプ愛用</p>
                </div>
              </div>
            </div>

            {/* レビュー3 */}
            <div className="bg-gradient-to-br from-sky-50/60 to-white rounded-2xl p-7 shadow-sm border border-sky-100/80 hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-yellow-400 text-base"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed mb-5 text-sm">
                友人に勧められて半信半疑で始めましたが、今では毎朝の習慣に。<strong>水に入れるだけという手軽さ</strong>が、忙しい朝でも無理なく続けられる理由です。
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-10 h-10 rounded-full bg-sky-100 flex items-center justify-center">
                  <i className="ri-user-3-line text-sky-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-800">A.Y さん</p>
                  <p className="text-xs text-gray-400">30代・女性｜石タイプ愛用</p>
                </div>
              </div>
            </div>

            {/* レビュー4 */}
            <div className="bg-gradient-to-br from-blue-50/40 to-white rounded-2xl p-7 shadow-sm border border-blue-100/80 hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4].map((star) => (
                  <i key={star} className="ri-star-fill text-yellow-400 text-base"></i>
                ))}
                <i className="ri-star-fill text-gray-200 text-base"></i>
              </div>
              <p className="text-gray-700 leading-relaxed mb-5 text-sm">
                粉タイプを使っています。水にサッと溶けるので扱いやすいです。<strong>自然由来のものでケアしたい</strong>という自分の考えに合っていて満足しています。
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                  <i className="ri-user-3-line text-blue-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-800">H.N さん</p>
                  <p className="text-xs text-gray-400">60代・男性｜粉タイプ愛用</p>
                </div>
              </div>
            </div>

            {/* レビュー5 */}
            <div className="bg-gradient-to-br from-sky-50/60 to-white rounded-2xl p-7 shadow-sm border border-sky-100/80 hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-yellow-400 text-base"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed mb-5 text-sm">
                寝室に置いて使っています。特別なことをしなくていいのが嬉しい。<strong>置くだけでいいという気軽さ</strong>が、ズボラな私にぴったりです。
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-10 h-10 rounded-full bg-sky-100 flex items-center justify-center">
                  <i className="ri-user-3-line text-sky-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-800">R.I さん</p>
                  <p className="text-xs text-gray-400">40代・女性｜粉タイプ愛用</p>
                </div>
              </div>
            </div>

            {/* レビュー6 */}
            <div className="bg-gradient-to-br from-blue-50/40 to-white rounded-2xl p-7 shadow-sm border border-blue-100/80 hover:shadow-md transition-shadow duration-300">
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-yellow-400 text-base"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed mb-5 text-sm">
                家族みんなで使っています。石タイプは繰り返し使えるので<strong>コスパが良い</strong>のも嬉しいポイント。子どもがいる家庭でも安心して使えます。
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                  <i className="ri-user-3-line text-blue-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-800">Y.K さん</p>
                  <p className="text-xs text-gray-400">30代・男性｜石タイプ愛用</p>
                </div>
              </div>
            </div>
          </div>

          <p className="text-center text-xs text-gray-400 mt-8">
            ※ 個人の感想であり、効果効能を保証するものではありません。
          </p>
        </div>
      </section>

      {/* フッター */}
      <footer className="bg-[#F5F3EF] text-gray-800 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center">
            <a href="/" className="inline-block cursor-pointer mb-4">
              <img 
                src="https://static.readdy.ai/image/9a1512bab4190ab0a228d64d8d4a8f0a/2594d362aebf6344cbc924cc76664b34.jpeg" 
                alt="Somachi ロゴ"
                className="h-12 w-auto object-contain mx-auto"
              />
            </a>
            <p className="text-gray-500 text-sm mb-6">
              古代ソマチッドを含む鉱石由来の健康サポートアイテム
            </p>
            <div className="border-t border-gray-300 pt-6">
              <p className="text-gray-400 text-sm">
                &copy; 2025 Somachi. All rights reserved. | 
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="nofollow noopener noreferrer" className="ml-2 hover:text-sky-600 transition-colors cursor-pointer">
                  Powered by Readdy
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
